import { useRef, useState } from 'react';
import { i18n } from '@lingui/core';
import { t } from '@lingui/core/macro';
import { I18nProvider } from '@lingui/react';
import {
  Banner,
  HelpIcon,
  LoadingIndicator,
  Tooltip
} from '@thermon-platforms/thermon-ui-core';
import { Trans } from '@lingui/react/macro';
import api from 'util/api';
import { getConfigItem } from 'util/device';


function PowerModal({device, controller, close, dismiss}) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();
  const config = controller.configuration.find(section => section.section == 'Circuit');
  const powerStates = config?.items.find(item => item.key == 'PowerState');
  const powerState = getConfigItem(device, 'PowerState')
  const value = useRef(powerState?.requestedValue || powerState?.value);

  async function finish() {
    setErrors(undefined);
    setLoading(true);

    // Fake request delay
    api(`/devices/${device.id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        type: device.type,
        configuration: [
          {
            key: 'PowerState',
            value: value.current
          }
        ]
      })
    })
      .then(() => {
        close();
      })
      .catch(async res => {
        setErrors(await res.json());
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3><Trans>Select Power Mode</Trans>: <strong>{device.name}</strong></h3>
      </header>
      <section>
        <Banner show={errors} status="alert" small={true}>
          <Trans>There was an issue updating the Power State.</Trans>
        </Banner>
        <Banner show={powerState?.value == 'Tripped'} status="alert" small={true}>
          <Trans>This circuit is currently tripped. Power Mode cannot be changed.</Trans>
        </Banner>
        <ul className="form" onChange={event => value.current = event.target.value}>
          {powerStates.options.map(option => <li key={`power-state-option-${option.value}`}>
            <label>
              <span
                data-tooltip-html={
                  ((value.current == option.value) &&
                  powerState?.requestedValue &&
                  (powerState?.requestedValue != powerState?.value)) ?
                  t`This power state is pending` : ''
                }
                data-tooltip-id={`power-state-tooltip`}
                data-tooltip-offset={24}
              >
                <input
                  type="radio"
                  id={`power-state-${option.value}`}
                  name="power-state"
                  value={option.value}
                  defaultChecked={value.current == option.value}
                  disabled={powerState?.value == 'Tripped'}

                />
                {option.displayName}
                {option.description ? <HelpIcon text={option.description} /> : <></>}
                {(
                  (value.current == option.value) &&
                  powerState?.requestedValue &&
                  (powerState?.requestedValue != powerState?.value)) ?
                  <>&nbsp;<LoadingIndicator show={true} /></>
                : <></>}
              </span>
            </label>
          </li>)}
        </ul>
        <Tooltip id={`power-state-tooltip`} place="right" />
      </section>
      <footer>
        <button onClick={dismiss}>
          <Trans>Cancel</Trans>
        </button>
        <button
          className={`primary ${loading ? 'processing' : ''}`}
          onClick={finish}
          disabled={loading || powerState?.value == 'Tripped'}
        >
          <Trans>Save</Trans>
        </button>
      </footer>
    </I18nProvider>
  )
}

export default PowerModal;
